module.exports = __webpack_public_path__ + "Fonts/material-design.woff";


//////////////////
// WEBPACK FOOTER
// ./app/Style/material-design/material-design.woff?v=2.2.0
// module id = 377
// module chunks = 4